import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherListElementVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveTeachers = createAsyncThunk<TeacherListElementVM[], void, { extra: Partial<Dependencies> }>(
  "teachers/adminRetrieveTeachers",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listTeachers();
  },
);
